import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./ListarCobrancas.css";
import { formatarDataBrasil } from "../../utils/utils";

export default function ListagemCobrancas() {
  const [cobrancas, setCobrancas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFiltro, setStatusFiltro] = useState("");
  const [buscaCliente, setBuscaCliente] = useState("");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  const buscarCobrancasFiltradas = async () => {
    setLoading(true);
  
    const queryParams = new URLSearchParams();
  
    if (statusFiltro) queryParams.append("status", statusFiltro);
    if (buscaCliente) queryParams.append("cliente", buscaCliente);
    if (dataInicio) queryParams.append("data_inicio", dataInicio);
    if (dataFim) queryParams.append("data_fim", dataFim);
  
    const url = `https://welaunchyou.com.br/crm-wly/api/financeiro/listar_cobrancas.php?${queryParams.toString()}`;
  
    try {
      const response = await fetch(url);
      const data = await response.json();
      setCobrancas(data);
    } catch (error) {
      console.error("Erro ao buscar cobranças", error);
    } finally {
      setLoading(false);
    }
  };
  
  

  // 1️⃣ Função para carregar as cobranças
  useEffect(() => {
    buscarCobrancasFiltradas(); // 🔁 usa a função nova
  }, []);
  
  // 2️⃣ Função para gerar a NF via Asaas
  const handleGerarNota = async (idCobranca) => {
    if (!idCobranca) return;
    
    const requestData = { id_cobranca: idCobranca };
  
    console.log("🔹 Enviando requisição para criar NF:", JSON.stringify(requestData)); // 👀 Log para depuração
  
    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/api/integracoes/criar_nota_asaas.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(requestData)
        }
      );
      const data = await response.json();
      
      console.log("🔸 Resposta do backend:", data); // 👀 Log para depuração
  
      if (data.success) {
        alert(`Nota fiscal gerada com sucesso! Acompanhe o status na página de Notas Fiscais.`);
      } else {
        alert(`Erro ao gerar nota fiscal. Tente novamente ou verifique na página de Notas Fiscais.`);
      }
    } catch (error) {
      alert(`Erro de rede ao gerar nota: ${error.message}`);
    }
  };
  

  return (
    <div className="listar-cobrancas-title">
      <h1 style={{ borderBottom: "none" }}>Lista de Cobranças</h1>
      <div className="listar-cobrancas-container">

        {/* Filtros */}
        <div className="listar-cobrancas-filtros">
          <input
            className="listar-cobrancas-input"
            placeholder="Buscar Cliente"
            value={buscaCliente}
            onChange={(e) => setBuscaCliente(e.target.value)}
          />

          <select
            className="listar-cobrancas-select"
            value={statusFiltro}
            onChange={(e) => setStatusFiltro(e.target.value)}
          >
            <option value="">Todos</option>
            <option value="COBRADO">Cobrado</option>
            <option value="PAGO">Pago</option>
            <option value="ATRASADO">Atrasado</option>
          </select>

          <input
            type="date"
            className="listar-cobrancas-date"
            value={dataInicio}
            onChange={(e) => setDataInicio(e.target.value)}
          />

          <input
            type="date"
            className="listar-cobrancas-date"
            value={dataFim}
            onChange={(e) => setDataFim(e.target.value)}
          />
          
<button className="listar-cobrancas-button" onClick={buscarCobrancasFiltradas}>
  Filtrar
</button>
          <button className="listar-cobrancas-button primary">
            <Link to="/financeiro/criar-cobranca" style={{ textDecoration: "none", color: "white" }}>
              Novo
            </Link>
          </button>
        </div>

        {/* Tabela de cobranças */}
        {loading ? (
          <p>Carregando...</p>
        ) : (
          <table className="listar-cobrancas-table">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Valor</th>
                <th>Vencimento</th>
                <th>Data Pagamento</th>
                <th>Pagamento</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {cobrancas.map((cobranca) => {
                console.log(`Cobranca ${cobranca.id} - Status: ${cobranca.status}`);

                return (
                  <tr key={cobranca.id}>
                    <td>{cobranca.cliente}</td>
                    <td>R$ {parseFloat(cobranca.valor).toFixed(2)}</td>
                    <td>{formatarDataBrasil(cobranca.vencimento)}</td>
                    <td>{cobranca.data_pagamento ? formatarDataBrasil(cobranca.data_pagamento) : '-'}</td> 
                    <td>{cobranca.tipo_pagamento}</td>
                    <td>{cobranca.status}</td>
                    <td style={{ display: "flex", gap: "5px" }}>
                      {/* Botão de Detalhes */}
                      <Link to={`/financeiro/detalhes/${cobranca.id}`}>
                        <button className="listar-cobrancas-button detalhes">Ver Detalhes</button>
                      </Link>

                      {/* Botão de Gerar NF (só aparece se status for PAGO) */}
                      {cobranca.status === "PAGO" && (
                        <button
                          className="listar-cobrancas-button nf"
                          onClick={() => handleGerarNota(cobranca.id)}
                        >
                          🧾 Gerar NF
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
